<template>
  <b-card>
    <b-row class="mt-1">
      <b-col cols="12">
        <h4 v-if="consultant.name">{{ consultant.name }}</h4>
        <h5>Informações da campanha DNA Campeão 🎉</h5>
      </b-col>
    </b-row>
    <b-row class="justify-content-end">
      <b-button class="mx-2" variant="outline-primary" :to="{
        name: 'consultant-dna-campaign-save',
        params: { id },
      }">
        <feather-icon icon="PlusCircleIcon" class="mr-50" />
        <span class="text-nowrap">Novo registro</span>
      </b-button>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="12">
        <b-table striped hover :items="dnaHistory" :fields="tableColumns" :per-page="itemsPerPage"
          :current-page="currentPage" :busy="loading">
          <template #cell(year_reference)="data">
            {{ data.item.year_reference }}
          </template>
          <template #cell(month_reference)="data">
            {{ data.item.month_reference }}
          </template>
          <template #cell(apprentice_score)="data">
            {{ data.item.apprentice_score }}
          </template>
          <template #cell(focused_score)="data">
            {{ data.item.focused_score }}
          </template>
          <template #cell(protagonist_score)="data">
            {{ data.item.protagonist_score }}
          </template>
          <template #cell(champion_score)="data">
            {{ data.item.champion_score }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import _ from "lodash";
import { BRow, BCol, BCard, BButton } from "bootstrap-vue";
import { mapActions } from "vuex";
import * as sharedTypes from "@/modules/shared/store/types";
import * as types from "../store/types";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
  },
  props: ['id'],
  data() {
    return {
      consultant: {},
      loading: false,
      tableColumns: [
        { key: "year_reference", label: "Ano de competência" },
        { key: "month_reference", label: "Mês competência" },
        { key: "apprentice", label: "Aprendiz" },
        { key: "focused", label: "Focado" },
        { key: "protagonist", label: "Protagonista" },
        { key: "champion", label: "Campeão" },
      ],
      currentPage: 1,
      itemsPerPage: 12,
      dnaHistory: [],
    };
  },
  mounted() {
    this.getConsultant(this.id).then((response) => {
      this.consultant = response.data;
    });
    this.loadDnaHistory();
  },
  methods: {
    ...mapActions({
      getConsultant: sharedTypes.GET_CONSULTANT,
      getDnaHistory: types.GET_DNA_HISTORY,
    }),
    async loadDnaHistory() {
      this.loading = true;
      this.getDnaHistory({
        id: this.id,
        currentPage: this.currentPage,
        itemsPerPage: this.itemsPerPage,
      })
        .then((response) => {
          this.dnaHistory = response.data;
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao carregar histórico de DNA. Entre em contato com o setor de TI",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
